module.exports = __webpack_public_path__ + "img/semigloss.3307556f.png";